
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { FormInput } from "@/components/ui/form-input";
import { LoadingButton } from "@/components/ui/loading-button";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { toast } from "sonner";

const Step3Forwarding = ({ onNext, onPrev }: { onNext: () => void; onPrev: () => void }) => {
  const { onboarding, saveForwarding } = useOnboardingState();
  const [forward, setForward] = useState(onboarding?.forwarding_number || "");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    if (!forward.match(/^\+?[1-9]\d{7,}$/)) {
      setError("Enter valid destination number.");
      setLoading(false);
      return;
    }
    
    try {
      await saveForwarding(forward);
      toast.success("Forwarding configured successfully!", {
        description: "Calls will now be forwarded to your number.",
      });
      onNext();
    } catch (err) {
      console.error("Failed to save forwarding:", err);
      setError("Failed to save forwarding number. Please try again.");
      toast.error("Failed to configure forwarding", {
        description: "Please check your number and try again.",
      });
    } finally {
      setLoading(false);
    }
  }
  return (
    <form className="space-y-4" onSubmit={handleSave}>
      <FormInput
        label="Forward Calls To (PSTN number)"
        value={forward}
        onChange={(e) => setForward(e.target.value)}
        placeholder="e.g. +14165550123"
      />
      {error && <div className="text-red-500 text-sm">{error}</div>}
      <div className="flex space-x-2">
        <Button type="button" variant="secondary" onClick={onPrev}>Back</Button>
        <LoadingButton type="submit" loading={loading}>Continue</LoadingButton>
      </div>
    </form>
  );
};
export default Step3Forwarding;
